import { Table } from "flowbite-react"
import HeaderNote from "./HeaderNote";
import { useEffect } from "react";
import { useReducerAsState } from "../hooks/useReducerAsState";
import { ITemplate } from "../types/templates";

interface Props {
    template: ITemplate;
    settings: any;
    onChange: (data:any) => void;
}

interface State {
    notesLimit: number;
    settings: Array<any>;
}

const HeaderNoteList = (props: Props) => {
    const [state, setState] = useReducerAsState<State>({
        notesLimit: props.template?.notes ?? 0,
        settings: []
    })

    const onChange = (data: any, position: number) => {
        const settings = [...state.settings];
        settings[position] = data;
        setState({ settings });
        props.onChange(settings);
    }

    const renderItems = () => {
        if(!props.settings) return <></>
        const allowedNotes = props.template?.notes ?? 0;
        if(!props.template || allowedNotes === 0) return <></>
        const components = []
        for(let i = 0; i < state.notesLimit; i++) {
            components.push(<Table.Row key={`note-${i}`}>
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                    <HeaderNote 
                        data={props.settings[i]}
                        shouldClear={state.notesLimit !== allowedNotes}
                        onChange={(data: any, position: number) => onChange(data, position)} 
                        position={i} 
                    />
                </Table.Cell>
            </Table.Row>)
        }

        return components;
    }

    const handleChange = () => {
        const allowedNotes = props.template?.notes ?? 0;
        setState({ notesLimit: allowedNotes, settings: [] })
        setTimeout(() => {
            props.onChange([])
        }, 100)
    }

    useEffect(() => {
        setState({ settings: props.settings })
        // eslint-disable-next-line
    }, [props.settings])

    useEffect(() => {
       handleChange()
        // eslint-disable-next-line
    }, [props.template])

    return <Table>
       <Table.Body className="divide-y">
        {renderItems()}
       </Table.Body>
    </Table>
}

export default HeaderNoteList